/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */

import {BrowserCacheLocation, Configuration, LogLevel} from '@azure/msal-browser';
import {UserRights} from './access-rights';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

/**
 * Enter here the user flows and custom policies for your B2C application,
 * To learn more about user flows, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        signUpSignIn: 'B2C_1_UMS_MSAL',
        resetPassword: 'B2C_1_passwordReset',
        editProfile: 'B2C_1_editProfile',
    },
    authorities: {
        signUpSignIn: {
            authority: 'https://aumacloudb2c.b2clogin.com/aumacloudb2c.onmicrosoft.com/B2C_1_signUpSignIn',
        },
        resetPassword: {
            authority: 'https://aumacloudb2c.b2clogin.com/aumacloudb2c.onmicrosoft.com/B2C_1_passwordReset',
        },
        editProfile: {
            authority: 'https://aumacloudb2c.b2clogin.com/aumacloudb2c.onmicrosoft.com/B2C_1_editProfile',
        },
    },
    authorityDomain: 'aumacloudb2c.b2clogin.com',
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
    auth: {
        clientId: '7de41454-6739-40f0-9f79-2d65183b6481', // This is the ONLY mandatory field that you need to supply.
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Defaults to "https://login.microsoftonline.com/common"
        knownAuthorities: [b2cPolicies.authorityDomain, 'aumacloudb2c.onmicrosoft.com'], // Mark your B2C tenant's domain as trusted.
        redirectUri: '/', // Points to window.location.origin by default. You must register this URI on Azure portal/App Registration.
        postLogoutRedirectUri: '/', // Points to window.location.origin by default.
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge. Remove this line to use Angular Universal
    },
    system: {
        /**
         * Below you can configure MSAL.js logs. For more information, visit:
         * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
         */
        loggerOptions: {
            loggerCallback(logLevel: LogLevel, message: string) {
                if (authDebugEnabled)
                    console.log(message)
            },
            logLevel: LogLevel.Trace,
            piiLoggingEnabled: false
        }
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
const authDebugEnabled = false;

export const loginRequest = {
    scopes: []
};

export const scopeConfig = 'openid offline_access https://aumacloudb2c.onmicrosoft.com/rism/access';
export const loginRestrictions = [UserRights.RIS2_MANAGEMENT_ENV_ACCESS];
